/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Replace_LabelInputs */



/**
* | output |
* | --- |
* | "Replace captions already in the file" |
*
* @param {Embed_Captions_Local_Replace_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_replace_label = /** @type {((inputs?: Embed_Captions_Local_Replace_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Replace_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Remplacer les légendes déjà présentes dans le fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ersetzen Sie die bereits in der Datei vorhandenen Bildunterschriften.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sostituisci le didascalie già presenti nel file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Замените подписи, уже имеющиеся в файле.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reemplazar los subtítulos que ya están en el archivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("替换文件中已有的标题")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル内に既に存在するキャプションを置き換える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल में पहले से मौजूद कैप्शन बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Substituir legendas já existentes no arquivo")
	return /** @type {LocalizedString} */ ("Replace captions already in the file")
});